import {Pl3xMap} from "../Pl3xMap";
import {BlockInfoControl} from "./BlockInfoControl";
import {CoordsControl} from "./CoordsControl";
import {LinkControl} from "./LinkControl";
import {ChunkGridControl} from "./ChunkGridControl";
import {MarkerPlacementControl} from "./MarkerPlacementControl";
import {MarkerToggleControl} from "./MarkerToggleControl";
import SidebarControl from "./SidebarControl";

export class ControlManager {
    private readonly _pl3xmap: Pl3xMap;

    private _sidebarControl?: SidebarControl
    private _blockInfoControl?: BlockInfoControl;
    private _coordsControl?: CoordsControl;
    private _linkControl?: LinkControl;
    private _chunkGridControl?: ChunkGridControl;
    private _markerPlacementControl?: MarkerPlacementControl;
    private _markerToggleControl?: MarkerToggleControl;

    constructor(pl3xmap: Pl3xMap) {
        this._pl3xmap = pl3xmap;
    }

    get sidebarControl(): SidebarControl | undefined {
        return this._sidebarControl;
    }

    set sidebarControl(control: SidebarControl | undefined) {
        this._sidebarControl?.remove();
        this._sidebarControl = control;
        this._sidebarControl?.addTo(this._pl3xmap.map);
    }

    get blockInfoControl(): BlockInfoControl | undefined {
        return this._blockInfoControl;
    }

    set blockInfoControl(control: BlockInfoControl | undefined) {
        this._blockInfoControl?.remove();
        this._blockInfoControl = control;
        this._blockInfoControl?.addTo(this._pl3xmap.map);
    }

    get coordsControl(): CoordsControl | undefined {
        return this._coordsControl;
    }

    set coordsControl(control: CoordsControl | undefined) {
        this._coordsControl?.remove();
        this._coordsControl = control;
        this._coordsControl?.addTo(this._pl3xmap.map);
    }

    get linkControl(): LinkControl | undefined {
        return this._linkControl;
    }

    set linkControl(control: LinkControl | undefined) {
        this._linkControl?.remove();
        this._linkControl = control;
        this._linkControl?.addTo(this._pl3xmap.map);
    }

    get chunkGridControl(): ChunkGridControl | undefined {
        return this._chunkGridControl;
    }

    set chunkGridControl(control: ChunkGridControl | undefined) {
        this._chunkGridControl?.remove();
        this._chunkGridControl = control;
        this._chunkGridControl?.addTo(this._pl3xmap.map);
    }

    get markerToggleControl(): MarkerToggleControl | undefined {
        return this._markerToggleControl;
    }

    set markerToggleControl(control: MarkerToggleControl | undefined) {
        this._markerToggleControl?.remove();
        this._markerToggleControl = control;
        this._markerToggleControl?.addTo(this._pl3xmap.map);
    }

    // Lives in the sidebar button strip, so it is not added to the map itself.
    get markerPlacementControl(): MarkerPlacementControl | undefined {
        return this._markerPlacementControl;
    }

    set markerPlacementControl(control: MarkerPlacementControl | undefined) {
        this._markerPlacementControl?.stop();
        this._markerPlacementControl = control;
    }
}
